import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { NavBarEditor, NavBarMain, NavBarSwitcher } from '@sloyd/ui';
import { useMemo } from 'react';
import { $a, invokeEvent } from 'shared-base';

export type NavBarContainerProps = {};

export function NavBarContainer(props: NavBarContainerProps) {
  const dispatch = useDispatch();
  const navBar = useSelector(selectors.bars.$navBar);

  const callbacks = useMemo(
    () => ({
      onNavigate: (path: string) => {
        invokeEvent('nav', { path });
      },
      onAction: (action: Action) => {
        dispatch(action);
      },
      onResize: (width: number) => {
        dispatch($a('EDITOR', 'resizeNavBar', '', { width }));
      },
    }),
    []
  );

  return (
    <NavBarSwitcher
      currentBarIndex={navBar.currentBarsIndex.navBarIndex}
      navbarWidth={navBar.navbarWidth}
      onResize={callbacks.onResize}
    >
      <NavBarMain data={navBar} callbacks={callbacks} />
      <NavBarEditor data={navBar} callbacks={callbacks} />
    </NavBarSwitcher>
  );
}
